module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNNS42MTU2NCA1LjM2Mzg5QzUuMjMxNTEgNS43MjIxNSA0LjYzNTY4IDUuNzIyMTUgNC4yNTE1NSA1LjM2Mzg5TDEuMTYwNzcgMi40ODEzMUMwLjQ5Njg5MiAxLjg2MjE0IDAuOTM1MDIxIDAuNzUgMS44NDI4MiAwLjc1SDguMDI0MzdDOC45MzIxNyAwLjc1IDkuMzcwMjkgMS44NjIxNCA4LjcwNjQxIDIuNDgxMzFMNS42MTU2NCA1LjM2Mzg5WiIgZmlsbD0iI0RERERERCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history/arrowRotate.svg
// module id = ne1E
// module chunks = 0